module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"inventories":"Inventuren","add":"Neu"},"en":{"inventories":"Inventories","add":"Add"}}')
  delete Component.options._Ctor
}
